// We import styles from this separate TS file, to keep imports order correct
import "./style.scss"
